import { contactConfig, headerLayout } from '../../config.js'
import { isMobile } from '../base'

function createHeaderIcons() {
    const navigationButtons = $('.navigation-buttons')
    $('.top-navigation-tools .top-nav-button').prependTo(navigationButtons)
}
function moveCartWidget() {
    const widgetsClones = $('.user-action-in')
    widgetsClones.appendTo('.header-top-wrapper')
}

function moveNavigation() {
    $('.js-navigation-container').insertAfter('.site-name');
}

function moveSearch() {
    $('#header .search').insertAfter('.header-top-wrapper');
}

function copyNavLinks() {
    const items = $('.top-navigation-bar .top-navigation-bar-menu > li').clone();
    if (!items.length) return;

    const pivot = $('#navigation .menu-level-1 > .menu-item-944').first();
    if (!pivot.length) return;

    const wrapperUl = $('<ul class="top-navigation-menu-mobile"></ul>');
    wrapperUl.append('<li class="top-navigation-menu-mobile-label">Ostatní</li>');
    wrapperUl.append(items);

    pivot.before(wrapperUl);
}

// obecná funkce, která shromažďuje všechny funkce, které elementy do hlavičky přidávají nebo někam přesunují
function moveAddHeaderElements() {
    createHeaderIcons()
    moveCartWidget()
    moveNavigation()
    moveSearch()
    copyNavLinks()

    $('.site-msg').insertBefore('.top-navigation-bar')
}
// Přidá třídu scrolled do body, pokud je uživatel scrolluje pro fungování fixní hlavičky
function addScrolledClass() {
    const mobileElements = [$('.site-msg.information')]

    const desktopElements = [$('.header-top'), $('.admin-bar'), $('.site-msg.information')]

    $(window).on('scroll', function () {
        const elements = isMobile() ? mobileElements : desktopElements

        const threshold = elements.reduce((sum, el) => {
            return sum + (el.is(':visible') ? el.outerHeight() || 0 : 0)
        }, 0)

        $('body').toggleClass('scrolled', $(this).scrollTop() > threshold)
    })
}

function addScrollDirectionClass() {
    let lastScrollTop = 0
    const window = $(window)
    const body = $('body')

    $(document).on('scroll', function () {
        const scrollTop = $(document).scrollTop()

        if (scrollTop > lastScrollTop) {
            body.removeClass('scrolled-up').addClass('scrolled-down')
        } else {
            body.removeClass('scrolled-down').addClass('scrolled-up')
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    })
}

function setSiteMsgHeightVar() {
    const siteMsgElement = $('.site-msg.information')
    const siteMsgHeight = siteMsgElement.length ? siteMsgElement.outerHeight() : 0

    document.documentElement.style.setProperty('--site-msg-height', `${siteMsgHeight}px`)

    $('.js-close-information-msg').on('click', function () {
        document.documentElement.style.setProperty('--site-msg-height', `0px`)
    })
}

function topNavigation() {
    $('.top-navigation-bar .container .top-navigation-menu')
        .after($(`<a href="tel:${contactConfig.phoneNumber}" class="top-navigation-tel">${contactConfig.phoneNumber}</a>`))
        .after($(`<a href="mailto:${contactConfig.mail}" class="top-navigation-mail">${contactConfig.mail}</a>`))
}

export function initHeader() {
    shoptet.config.mobileHeaderVersion = '0'
    moveAddHeaderElements()
    // addScrolledClass()
    addScrollDirectionClass()
    topNavigation()
    setSiteMsgHeightVar()

    document.addEventListener('resizeEnd', () => {
        setSiteMsgHeightVar()
    })
}
